import angular from 'angular';
import uiRouter from 'angular-ui-router';
import investorenComponent from './investoren.component';

let investorenModule = angular.module('investoren', [
  uiRouter
])

.component('investoren', investorenComponent)

.name;

export default investorenModule;



// WEBPACK FOOTER //
// ./client/app/common/forms/investoren/investoren.js